<div class="step-two-col">
  <div class="step-col-main">
    <div class="action-panel meeting-action-panel">
      <div class="action-panel-header">
        <i class="fa fa-arrows-h" style="margin-right:6px;"></i>
        {{ canAddMeeting() ? 'Need another meeting?' : 'Proceed to Advice' }}
      </div>

      <div class="action-panel-body">
        <p *ngIf="canAddMeeting()" class="action-panel-desc">
          Do you need another intermediate meeting with the project, or are you ready to provide your advice on the activities to perform?
        </p>
        <p *ngIf="!canAddMeeting()" class="action-panel-desc">
          The Proposal Support Service includes at most two meetings. Please proceed to provide your advice on the activities to perform.
        </p>

        <div class="yes-no-row">
          <button *ngIf="canAddMeeting()" (click)="skip(false)" class="btn btn-default action-btn action-btn--secondary">
            <i class="fa fa-arrow-right"></i> Go to meeting {{ MEETING_FORM + 2 }}
          </button>
          <button (click)="skip(true)" class="btn btn-primary action-btn">
            {{ canAddMeeting() ? 'Skip to Advice' : 'Proceed to Advice' }} <i class="fa fa-angle-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="step-col-report">
    <report></report>
  </div>
</div>
<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
